<div class="login-viewport">
  <mat-card class="login-card">
    <div class="logo-container">
      <img src="assets/images/logo.png" alt="Logo Esse 3" />
    </div>

    <!-- TOKEN MANCANTE O SCADUTO -->
    <ng-container *ngIf="tokenInvalid; else formBlock">
      <div class="token-invalid">
        <mat-icon>link_off</mat-icon>
        <h2>Link non valido</h2>
        <p>
          Il link che hai usato è scaduto o non è corretto.<br />
          Richiedi un nuovo link di reset dalla pagina di accesso.
        </p>
        <a esse-button variant="primary" routerLink="/reset-password">
          Richiedi nuovo link
        </a>
      </div>
    </ng-container>

    <!-- FORM NORMALE -->
    <ng-template #formBlock>
      <h1>Nuova Password</h1>
      <p class="subtitle">
        Scegli una nuova password sicura per il tuo account.
      </p>

      <form [formGroup]="form" (ngSubmit)="submit()" novalidate>

        <!-- NUOVA PASSWORD -->
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Nuova password</mat-label>
          <input
            matInput
            [type]="hidePassword ? 'password' : 'text'"
            formControlName="password"
            autocomplete="new-password"
            placeholder="Minimo 8 caratteri"
          />
          <button
            esse-button
            variant="icon"
            [icon]="hidePassword ? 'visibility' : 'visibility_off'"
            matSuffix
            type="button"
            (click)="hidePassword = !hidePassword"
            [attr.aria-label]="hidePassword ? 'Mostra password' : 'Nascondi password'"
          ></button>
          <mat-icon matPrefix fontSet="material-icons-outlined">lock</mat-icon>

          <mat-error *ngIf="f.password.touched && f.password.errors?.['required']">
            Inserisci la password.
          </mat-error>
          <mat-error *ngIf="f.password.touched && f.password.errors?.['minlength']">
            Minimo {{ f.password.errors?.['minlength']?.requiredLength }} caratteri.
          </mat-error>
        </mat-form-field>

        <!-- CONFERMA PASSWORD -->
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Conferma password</mat-label>
          <input
            matInput
            [type]="hideConfirm ? 'password' : 'text'"
            formControlName="confirmPassword"
            autocomplete="new-password"
            placeholder="Ripeti la nuova password"
          />
          <button
            esse-button
            variant="icon"
            [icon]="hideConfirm ? 'visibility' : 'visibility_off'"
            matSuffix
            type="button"
            (click)="hideConfirm = !hideConfirm"
            [attr.aria-label]="hideConfirm ? 'Mostra password' : 'Nascondi password'"
          ></button>
          <mat-icon matPrefix fontSet="material-icons-outlined">lock_reset</mat-icon>

          <mat-error *ngIf="f.confirmPassword.touched && f.confirmPassword.errors?.['required']">
            Conferma la password.
          </mat-error>
          <mat-error *ngIf="form.errors?.['passwordMismatch'] && f.confirmPassword.touched">
            Le password non coincidono.
          </mat-error>
        </mat-form-field>

        <!-- SUBMIT -->
        <button
          esse-button
          variant="primary"
          class="w-100 btn-submit"
          [disabled]="form.invalid || loading || success"
        >
          <ng-container *ngIf="!loading; else loadingTpl">
            Salva nuova password
          </ng-container>
        </button>

        <ng-template #loadingTpl>
          <span class="btn-loading">
            <mat-progress-spinner diameter="18" mode="indeterminate"></mat-progress-spinner>
            <span>Salvataggio…</span>
          </span>
        </ng-template>

        <!-- SUCCESS -->
        <div class="success" *ngIf="success">
          <mat-icon>check_circle</mat-icon>
          Password aggiornata! Verrai reindirizzato al login…
        </div>

        <!-- ERROR -->
        <div class="error" *ngIf="error">
          <mat-icon>error_outline</mat-icon>
          {{ error }}
        </div>

        <a class="back-link" routerLink="/login">Torna al login</a>
      </form>
    </ng-template>

  </mat-card>
</div>